import { encodeUrlValue } from 'src/adapters/urlEncoding';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import { compareStringsUtf16 } from './compareStringsUtf16';

/**
 * Serialises active facet filters as a canonical path segment of the form:
 *   /-/alias/value/alias/value/...
 *
 * Pairs are sorted by alias then by value (case-sensitive ASCII). Multi-value
 * filters repeat the alias: /c/blue/c/red. Returns an empty string when no
 * filters are active.
 */
export const serializeFilterPath = (facets: Facet[]): string => {
  const pairs: [string, string][] = [];

  facets.forEach((facet) => {
    facet.options.forEach((option) => {
      if (option.active) {
        pairs.push([facet.alias, encodeUrlValue(option.value)]);
      }
    });
  });

  if (pairs.length === 0) {
    return '';
  }

  pairs.sort((a, b) => {
    const aliasCmp = compareStringsUtf16(a[0], b[0]);
    return aliasCmp !== 0 ? aliasCmp : compareStringsUtf16(a[1], b[1]);
  });

  return '/-/' + pairs.map(([alias, value]) => `${alias}/${value}`).join('/');
};
